import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ContextMenuItemState {
  // optional
  public iconClass: string | null = null;

  public referencedOrderIds: string[] = [];
  public referencedDealIds: string[] = [];
  // Note this is for DI Cancel and usually unpopulated
  public referencedOrderData?: CubiqTS.OrderData[] = [];
  public referencedOpsExceptionId?: CubiqTS.OpsExceptionType[] = [];
  //
  public clearDialogReferencedIds? = new Map<string, string>();
  public referencedOpsIntIds: string[] = [];
  public isDialogOpening: boolean;

  constructor(
    public count: number = 0,
    public itemIndex: number = 0,
    public available: boolean = false,
    public enabled: boolean = false,
    public title: string = "",
  ) {}

  public get hasReferencedOrderIds(): boolean {
    return Array.isArray(this.referencedOrderIds) && this.referencedOrderIds.length !== 0;
  }

  public get hasReferencedDealIds(): boolean {
    return Array.isArray(this.referencedDealIds) && this.referencedDealIds.length !== 0;
  }

  public get hasReferencedOrderData(): boolean {
    return Array.isArray(this.referencedOrderData) && this.referencedOrderData.length !== 0;
  }

  public get hasReferencedOpsIntIds(): boolean {
    return Array.isArray(this.referencedOpsIntIds) && this.referencedOpsIntIds.length !== 0;
  }
}
